module.exports = __webpack_public_path__ + "img/8d38ee55c04c8c6fad72f8df7393eadd.svg";